import axios from 'axios';

export class HttpRequestLogsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getHttpRequestLogs(params) {
    return this.#http.get('/api/http-request-logs', { params });
  }

  async getBlobUrl({ blobStorageId }) {
    return this.#http.get(`/api/http-request-logs/blob/${blobStorageId}`);
  }

  async fetchBlobContent(url) {
    const { data } = await axios.get(url, {
      transformResponse: [response => response],
    });

    return data;
  }
}
